import { Component } from '@angular/core'
import { AuthService } from '../../services/login/auth.service'
import { Router } from '@angular/router'

@Component({
    selector: 'app-not-allowed',
    standalone: true,
    imports: [],
    templateUrl: './not-allowed.component.html',
    styleUrl: './not-allowed.component.css',
})
export class NotAllowedComponent {
    constructor(private authService: AuthService, private router: Router) {}

    logout() {
        this.authService.logout()
        this.router.navigate([''])
    }
}
